// InfoTip — small inline hover tooltip. Used to clarify semantics like
// "evidence vs sources" without cluttering the header.

import React, { useState } from "react";

const InfoTip = ({ children, label = "info", testId }) => {
    const [open, setOpen] = useState(false);
    return (
        <span
            className="relative inline-flex items-center"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
        >
            <button
                type="button"
                aria-label={label}
                data-testid={testId}
                className="inline-flex items-center justify-center w-4 h-4 rounded-full border border-[hsl(var(--line))] text-[9px] text-[hsl(var(--mute))] hover:text-[hsl(var(--ink))] hover:border-[hsl(var(--ink-soft))]"
                onClick={(e) => { e.preventDefault(); setOpen((v) => !v); }}
            >
                i
            </button>
            {open && (
                <span
                    role="tooltip"
                    className="absolute left-1/2 -translate-x-1/2 top-full mt-1 z-30 w-64 p-2.5 text-[11px] leading-snug normal-case tracking-normal font-normal rounded shadow-lg border border-[hsl(var(--line))] bg-[hsl(var(--surface-raised))] text-[hsl(var(--ink))]"
                >
                    {children}
                </span>
            )}
        </span>
    );
};

export default InfoTip;
